import * as React from "react";
import { Query } from "react-apollo";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { Col } from "reactstrap";
import * as moment from "moment";

// GraphQL
import GetCompanyRequests from "../../../GraphQL/Queries/GetCompanyRequests";

// Presentation/UI
import Loader from "../../../Components/Loader/DotLoader";

export default class CustomerRequests extends React.Component<{
  companyId: string;
}> {
  // Organize customer request chart data
  returnChartData = (data: any): Array<any> => {
    if (!data || !data.length) {
      return [];
    }

    let chartData: any = [];

    // Get the current week
    const startOfWeek = moment().startOf("week");
    const endOfWeek = moment().endOf("week");

    const days: any = [];
    let day = startOfWeek;

    while (day <= endOfWeek) {
      days.push(day.toDate());
      day = day.clone().add(1, "d");
    }

    const allRequests = data;

    // filter requests based on the day it was created

    // Sunday
    const sunrequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[0]).format("DD/MM/YYYY")
    );

    const sunData = {
      name: moment(days[0]).format("ddd"),
      Received: !sunrequests.length ? 0 : sunrequests.length,
      Accepted: !sunrequests.length
        ? 0
        : sunrequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: sunrequests.length
    };

    chartData = [...chartData, sunData];

    // Monday
    const monrequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[1]).format("DD/MM/YYYY")
    );

    const monData = {
      name: moment(days[1]).format("ddd"),
      Received: !monrequests.length ? 0 : monrequests.length,
      Accepted: !monrequests.length
        ? 0
        : monrequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: monrequests.length
    };

    chartData = [...chartData, monData];

    // Tuesday
    const tuerequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[2]).format("DD/MM/YYYY")
    );

    const tueData = {
      name: moment(days[2]).format("ddd"),
      Received: !tuerequests.length ? 0 : tuerequests.length,
      Accepted: !tuerequests.length
        ? 0
        : tuerequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: tuerequests.length
    };

    chartData = [...chartData, tueData];

    // Wednesday
    const wedrequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[3]).format("DD/MM/YYYY")
    );

    const wedData = {
      name: moment(days[3]).format("ddd"),
      Received: !wedrequests.length ? 0 : wedrequests.length,
      Accepted: !wedrequests.length
        ? 0
        : wedrequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: wedrequests.length
    };

    chartData = [...chartData, wedData];

    // Thursday
    const thurequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[4]).format("DD/MM/YYYY")
    );

    const thuData = {
      name: moment(days[4]).format("ddd"),
      Received: !thurequests.length ? 0 : thurequests.length,
      Accepted: !thurequests.length
        ? 0
        : thurequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: thurequests.length
    };

    chartData = [...chartData, thuData];

    // Friday
    const frirequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[5]).format("DD/MM/YYYY")
    );

    const friData = {
      name: moment(days[5]).format("ddd"),
      Received: !frirequests.length ? 0 : frirequests.length,
      Accepted: !frirequests.length
        ? 0
        : frirequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: frirequests.length
    };

    chartData = [...chartData, friData];

    // Saturday
    const satrequests = allRequests.filter(
      (request: any) =>
        moment(request.createdAt).format("DD/MM/YYYY") ===
        moment(days[6]).format("DD/MM/YYYY")
    );

    const satData = {
      name: moment(days[6]).format("ddd"),
      Received: !satrequests.length ? 0 : satrequests.length,
      Accepted: !satrequests.length
        ? 0
        : satrequests.filter((request: any) => request.status === "ACCEPT")
            .length,
      amt: satrequests.length
    };

    chartData = [...chartData, satData];

    return chartData;
  };

  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyRequests} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the requests</div>;
          }

          const requests = data.allRequests;
          const chartData = this.returnChartData(requests);

          return (
            <Col xs={12} md={6} lg={6}>
              <ResponsiveContainer>
                <LineChart
                  width={600}
                  height={300}
                  data={chartData}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis dataKey="name" />
                  <YAxis />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="Received"
                    stroke="#ffa366"
                    activeDot={{ r: 8 }}
                  />
                  <Line type="monotone" dataKey="Accepted" stroke="#33cccc" />
                </LineChart>
              </ResponsiveContainer>
            </Col>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardCharts/CustomerRequests.tsx